/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    code: "code",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    em: "em",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Properties"
    }), "\n", _jsxs(_components.p, {
      children: ["These properties can send along with the ", _jsx(_components.code, {
        children: "Accordion.Provider"
      }), " or ", _jsx(_components.code, {
        children: "Accordion.Group"
      }), ". It will affect every nested ", _jsx(_components.code, {
        children: "Accordion"
      }), "."]
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Accordion Properties"
          }), _jsx(_components.th, {
            children: "Description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "id"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " a unique ", _jsx(_components.code, {
              children: "id"
            }), " that will be used on the button element. If you use ", _jsx(_components.code, {
              children: "remember_state"
            }), ", an id is required."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "title"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " a title as a string or React element. It will be used as the button text."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "expanded"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), " the accordion will be expanded as its initial state."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "expanded_ssr"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), " the accordion will be expanded during SSR. Can be potentially useful for SEO, although it will disturb client hydration, where React expects the same state. But that's mainly a technical aspect to consider."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "remember_state"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), ", it will remember a changed state initiated by the user. It requires a unique ", _jsx(_components.code, {
              children: "id"
            }), ". It will store the sate in the local storage."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "flush_remembered_state"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), ", the saved (remembered) will be removed and the initial component state will be used and set."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "no_animation"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), ", the open and close animation will be omitted."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "variant"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " defines the used styling. ", _jsx(_components.code, {
              children: "outlined"
            }), ", ", _jsx(_components.code, {
              children: "filled"
            }), ", or ", _jsx(_components.code, {
              children: "plain"
            }), "(no styling). Defaults to ", _jsx(_components.code, {
              children: "outlined"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "icon"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " will replace the ", _jsx(_components.code, {
              children: "chevron"
            }), " icon. The icon will still rotate (by CSS). You can use an object to use two different icons, one for the closed state and one for the expanded state ", _jsx(_components.code, {
              children: "{ closed, expanded }"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "icon_position"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " will set the placement of the icon. Defaults to ", _jsx(_components.code, {
              children: "left"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "icon_size"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " define a different icon size. Defaults to ", _jsx(_components.code, {
              children: "medium"
            }), " (1.5rem)."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "left_component"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " will add a React element on the left side of the ", _jsx(_components.code, {
              children: "title"
            }), ", inside ", _jsx(_components.code, {
              children: "AccordionHeaderContainer"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "prerender"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), " the content will be present, even the accordion is not expanded. Can be useful for assistive technology or SEO."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "prevent_rerender"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), " the accordion component will not re-render its content – can be useful for widgets you don't have control of storing the temporary state during an interaction."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "prevent_rerender_conditional"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " use this prop together with ", _jsx(_components.code, {
              children: "prevent_rerender"
            }), " – and if it is to ", _jsx(_components.code, {
              children: "true"
            }), ", the accordion component will re-render if the children are a new React element and does not match the previous one anymore."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "single_container"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), ", a group of accordions will be wrapped to sidebar looking menu for medium and larger screens."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "element"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " gives you the option to replace the used ", _jsx(_components.code, {
              children: "button"
            }), " element. Provide a React element, including a string (HTML element). Defaults to a ", _jsx(_components.code, {
              children: "div"
            }), " with all the needed accessibility features included."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "heading"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), ", level 2 (h2) will be used. You can provide your own HTML heading (", _jsx(_components.code, {
              children: "h3"
            }), "), or provide a ", _jsx(_components.code, {
              children: "heading_level"
            }), " property."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "heading_level"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if ", _jsx(_components.code, {
              children: "heading"
            }), " is set to ", _jsx(_components.code, {
              children: "true"
            }), ", you can provide a numeric value to define a different heading level. Defaults to ", _jsx(_components.code, {
              children: "2"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "disabled"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), ", the accordion button will be disabled (dimmed)."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "skeleton"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), ", an overlaying skeleton with animation will be shown."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "contentRef"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " send along a custom React Ref for ", _jsx(_components.code, {
              children: ".dnb-accordion__content"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/uilib/layout/space/properties",
              children: "Space"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " spacing properties like ", _jsx(_components.code, {
              children: "top"
            }), " or ", _jsx(_components.code, {
              children: "bottom"
            }), " are supported."]
          })]
        })]
      })]
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Accordion.Provider and Accordion.Group Properties"
          }), _jsx(_components.th, {
            children: "Description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "group"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " define a unique id, it will be used to \"group\" several accordions into one."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "allow_close_all"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), ", the group of accordions will allow all to close."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "expanded_id"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " define an ", _jsx(_components.code, {
              children: "id"
            }), " of a nested accordion that will get expanded."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/uilib/layout/space/properties",
              children: "Space"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " spacing properties like ", _jsx(_components.code, {
              children: "top"
            }), " or ", _jsx(_components.code, {
              children: "bottom"
            }), " are supported."]
          })]
        })]
      })]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
